import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'leaflet/dist/leaflet.css';
import { GoogleOAuthProvider } from "@react-oauth/google";

// Read referralId cookie and persist for later use
function getCookie(name: string) {
  if (typeof document === 'undefined') return undefined;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return undefined;
}

try {
  const referralId = getCookie('referralId');
  if (referralId) {
    localStorage.setItem('referralId', referralId);
  }
} catch (err) {
  // ignore in non-browser environments
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <GoogleOAuthProvider clientId="863497232948-6vhgtbmtsq2rodu4s2ib3vo10ahoq8td.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
  </React.StrictMode>
);


